import React from "react";
import { LINKS } from "../data/site";

export default function Register() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 text-white">
      <h1 className="text-4xl font-bold mb-4">
        U2 Gaming Register Malaysia
      </h1>

      <p className="text-lg opacity-80 mb-8">
        Register your U2 Gaming account today and enjoy up to 200% welcome bonus.
        Start playing Malaysia’s top online casino with fast withdrawal and secure system.
      </p>

      <div className="flex gap-4 mb-10">
        <a
          href={LINKS.register}
          className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-xl font-semibold transition"
        >
          Register U2 Gaming Now
        </a>

        <a
          href={LINKS.login}
          className="border border-orange-500 px-6 py-3 rounded-xl"
        >
          Login Now
        </a>
      </div>

      <h2 className="text-2xl font-semibold mb-4">
        Why Choose U2 Gaming Malaysia?
      </h2>

      <ul className="space-y-2 opacity-80">
        <li>⚡ Fast withdrawal within 3 minutes</li>
        <li>🏦 Supports Maybank, CIMB, TnG, Boost</li>
        <li>🎮 500+ casino games</li>
        <li>📞 24/7 support via Telegram & WhatsApp</li>
      </ul>
    </div>
  );
}
